import React, { useCallback } from "react";
import { Link, useParams } from "react-router-dom";
import { imageBasePath } from "../../Utils/config";
import { servicesLabels } from "../../Utils/data";
import MassageCard from "../../Components/MassageCard/MassageCard";

const ServiceDetails = () => {
  const { id: serviceId } = useParams();
  const service = servicesLabels?.find(({ id }) => id === serviceId);

  const getNextRoute = useCallback(() => {
    if (
      servicesLabels?.findIndex(({ id }) => id === serviceId) ===
      servicesLabels?.length - 1
    )
      return "/services";
    return (
      "/services/" +
      servicesLabels[
        servicesLabels?.findIndex(({ id }) => id === serviceId) + 1
      ]?.id
    );
  }, [serviceId]);
  return (
    <>
      <div className="container mx-auto flex flex-col justify-center items-center pt-20 md:pt-28 pb-10 md:pb-18">
        {!!service?.image && (
          <div className="flex justify-center items-center w-[88px] h-[88px] rounded-2xl border border-solid border-[#141414]">
            <img
              src={imageBasePath + service?.image}
              alt={"Icon" + service?.serviceName}
            />
          </div>
        )}
        {!!service?.serviceName && (
          <p className="font-font-Montserrat text-[#141414] text-2xl md:text-4xl lg:text-5xl text-center leading-[32px] sm:leading-[62px] font-semibold tracking-wide uppercase pt-4 sm:pt-8">
            {service?.serviceName}
          </p>
        )}
        {!!service?.serviceImages?.length && (
          <div>
            <div
              className={
                ["Cupping Therapy", "Health Check", "Kinesiotaping"]?.includes(
                  service?.serviceName
                )
                  ? `flex flex-col lg:flex-row justify-center items-center py-16 px-4 sm:px-0`
                  : `grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-${service?.serviceImages?.length} gap-4 justify-center items-center py-16 px-4 sm:px-0`
              }
            >
              {service?.serviceImages?.map((image, index) => (
                <img
                  key={index + 1}
                  src={imageBasePath + image}
                  alt={"image" + index}
                  className={
                    "px-1 sm:px-2 py-2 lg:py-0" +
                    service?.serviceImagesClasses?.[index]
                  }
                />
              ))}
            </div>
          </div>
        )}
        {!!service?.description && (
          <div className="flex items-center justify-center pt-4 w-4/5">
            <p className="col-span-3 font-font-Titillium text-base md:text-xl text-[#262626] leading-[22px] sm:leading-[32px] text-center font-normal tracking-wide">
              {service?.description}
            </p>
          </div>
        )}
        {!!service?.serviceName?.includes("Imaging") && (
          <div className="flex items-center justify-center pt-4 w-4/5">
            <p className="col-span-3 font-font-Titillium text-base md:text-xl text-[#262626] leading-[22px] sm:leading-[32px] text-left font-normal tracking-wide whitespace-pre-wrap">
              We have teamed up with London Imaging Company “ORYON” to provide
              our member and patients and their friends and family access to the
              same service level treatment as our premier athletes which means
              through our network you can have scans and relevant imaging as
              needed with 24-72 hours’ notice.
              <br />
              {"                \n"}
              The service and staff are highly skilled, your images are provided
              to you on a disk and the result are sent to your clinician.
              <br />
              {"                \n"}
              Booking your appointment with us for a fast-reliable service, a
              referral is required to access the first-class service which can
              be attained through SILC. Call or email us today, or book an
              appointment
            </p>
          </div>
        )}
        {!!service?.descriptions?.length &&
          service?.descriptions?.map((item) => (
            <div className="flex items-center justify-center w-4/5">
              <p className="col-span-3 font-font-Titillium text-[16px] md:text-[20px] text-[#262626] leading-[22px] sm:leading-[32px] text-center font-normal tracking-wide">
                {item}
              </p>
            </div>
          ))}
        {!!service?.massageTitle && (
          <p className="font-font-Montserrat text-[#262626] text-2xl text-center leading-[31px] font-medium pt-8 sm:pt-8">
            {service?.massageTitle}
          </p>
        )}

        {!!service?.massage?.length && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 py-6">
            {service?.massage?.map(({ title, description }) => (
              <MassageCard title={title} description={description} />
            ))}
          </div>
        )}
      </div>
      {!!service?.serviceName?.includes("Imaging") && (
        <div className="w-full my-8">
          <div className="bg-[#f5f5f5]">
            <div className="container mx-auto flex items-center mt-4 max-w-[73%] py-4">
              <div className="grid grid-cols-7 gap-4 items-center mx-auto">
                <img
                  src={imageBasePath + service?.imagingImage}
                  alt="message"
                  // className="col-span-1"
                />
                <p className="font-font-Titillium font-normal text-xl tracking-wide text-right text-[#262626] leading-[30px] col-span-6">
                  London Imaging Centre is a leading independent diagnostic
                  closed operation provider conveniently located in the heart of
                  London’s Harley Street District. They are open 8AM-8PM, seven
                  days a week providing a diverse range of excellent imaging
                  services at a special rate for self-funding patients.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="container mx-auto flex flex-col justify-center items-center">
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6 items-center justify-center text-center sm:text-start py-4 sm:py-8">
          <Link
            to="/services"
            className="lg:col-span-2 font-font-Titillium text-base md:text-lg text-[#141414] leading-[27px] font-semibold uppercase underline tracking-widest"
          >
            {"< VIEW SERVICES List"}
          </Link>
          <Link
            to={`/book/${serviceId}`}
            className="font-font-Titillium flex items-center justify-center rounded-3xl bg-[#FFD666] shadow-[0px_0px_1px_rgba(20, 20, 20, 0.08), 0px_1px_8px_2px_rgba(20, 20, 20, 0.08)] text-base md:text-lg text-[#141414] leading-[27px] font-semibold uppercase tracking-widest w-[240px] h-[48px]"
          >
            <p>Pay Now</p>
          </Link>
          <Link
            to={`/book/${serviceId}`}
            className="font-font-Titillium flex items-center justify-center rounded-3xl bg-[#FFD666] shadow-[0px_0px_1px_rgba(20, 20, 20, 0.08), 0px_1px_8px_2px_rgba(20, 20, 20, 0.08)] text-base md:text-lg text-[#141414] leading-[27px] font-semibold uppercase tracking-widest w-[240px] h-[48px]"
          >
            <p>BOOK APPOINTMENT</p>
          </Link>
          <Link
            to={getNextRoute()}
            className="font-font-Titillium text-base md:text-lg text-[#141414] leading-[27px] font-semibold uppercase underline tracking-widest"
          >
            {"View Next Service >"}
          </Link>
        </div>
      </div>
    </>
  );
};

export default ServiceDetails;
